export class ReminderDetails {
    confirmationNumber: string;
    reminderType: string;
    contactNumber: string;
    notificationSelected: Boolean;
}
